module.exports = __webpack_public_path__ + "img/ai-button.12edf9b7.png";